import "./pulse_loader.css";
import React from "react";

interface PulseLoaderProps {
  color?: string;
  size?: number;
}

export function PulseLoader(props: PulseLoaderProps) {
  const { color, size = 18 } = props;

  return (
    <div style={{ height: size }} className="sk-three-bounce d-flex">
      <div
        className="pulse-loader-dot"
        style={{
          ...(color && { backgroundColor: color }),
          width: size,
          height: size,
        }}
      />
      <div
        className="pulse-loader-dot"
        style={{
          ...(color && { backgroundColor: color }),
          width: size,
          height: size,
        }}
      />
      <div
        className="pulse-loader-dot"
        style={{
          ...(color && { backgroundColor: color }),
          width: size,
          height: size,
        }}
      />
    </div>
  );
}
